import { render, staticRenderFns } from "./inspector-user-list.vue?vue&type=template&id=3227c99f&scoped=true"
import script from "./inspector-user-list.vue?vue&type=script&lang=js"
export * from "./inspector-user-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227c99f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3227c99f')) {
      api.createRecord('3227c99f', component.options)
    } else {
      api.reload('3227c99f', component.options)
    }
    module.hot.accept("./inspector-user-list.vue?vue&type=template&id=3227c99f&scoped=true", function () {
      api.rerender('3227c99f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/account-management/inspector-user-management/inspector-user-list.vue"
export default component.exports